<template>
  <div class="settingsSectionIntegration">
    <div v-if="isIntegrationConnected" class="settingsSectionIntegration__connected__icon">
      <IconCheck />
    </div>
    <div class="settingsSectionIntegration__icon">
      <component :is="integration.icon"></component>
    </div>
    <div class="settingsSectionIntegration__name">{{ integration.name }}</div>
    <div class="settingsSectionIntegration__info">{{ integration.info }}</div>
    <button v-if="!isIntegrationConnected" class="settingsSectionIntegration__connect" @click="initConnect(integration.app)">Connect</button>
    <button v-else class="settingsSectionIntegration__connect" @click="initDisconnect(integration.app)">Disconnect</button>
  </div>
</template>

<script>
import { SettingsStore } from "../ELYXStore";
import { initConnect, initDisconnect } from "./integrationsHelpers";
import IconCheck from "../../ELYXIcons/IconCheck.vue";

export default {
  props: {
    integration: Object,
  },
  components: {
    IconCheck,
    IconGoogleCalendar: () => import(/* webpackPrefetch: true */ "../../ELYXIcons/IconGoogleCalendar.vue"),
  },
  computed: {
    isIntegrationConnected() {
      return SettingsStore.state.integrations[this.integration.app];
    },
  },
  methods: {
    initConnect: initConnect,
    initDisconnect: initDisconnect,
  },
};
</script>

<style scoped>
.settingsSectionIntegration {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  background-color: rgb(255 255 255 / 0.8);
  border-radius: 16px;
  padding: 15px;
  box-sizing: border-box;
  width: 300px;
}
.settingsSectionIntegration__info {
  line-height: 22px;
  margin-bottom: 15px;
  color: var(--secondary-color);
  text-align: center;
}
.settingsSectionIntegration__icon {
  height: 44px;
  width: 44px;
}
.settingsSectionIntegration__name {
  font-size: 18px;
  font-weight: 500;
  margin: 15px 0;
  color: var(--primary-color);
}
.settingsSectionIntegration__connect {
  font-size: 16px;
  font-weight: 500;
  padding: 5px 0;
  border-radius: 360px;
  cursor: pointer;
  transition: 0.1s ease;
  text-align: center;
  outline: none;
  border-color: unset;
  box-sizing: border-box;
  width: 100%;
  margin: auto;
  font-family: "Nunito", sans-serif;
  background-color: var(--primary-color);
  color: white;
}
.settingsSectionIntegration__connect:hover {
  background-color: #555;
}
.settingsSectionIntegration__connected__icon {
  position: absolute;
  right: 15px;
  top: 15px;
  width: 10px;
  height: 10px;
  padding: 5px;
  display: flex;
  background-color: #d9ffd9;
  justify-content: center;
  align-items: center;
  border-radius: 360px;
}
</style>
